<template>
  <div class="user-badge d-flex align-center background-post-tint color-post-background font-size-small font-weight-bold rounded-app" shrink>
    <div v-if="badge.icon_url && badge.icon_url.original" class="icon-wrapper">
      <inline-svg
        class="inline-svg-icon color-post-background ml-1"
        :class="{ 'mr-1': !badge.name }"
        :height="12"
        :width="12"
        :src="badge.icon_url.original"
        :title="badge.name || 'Badge icon'"
      />
    </div>
    <div v-if="badge.name" class="user-badge-text" :class="{ 'user-badge-text--with-icon': badge.icon_url && badge.icon_url.original }">{{ badge.name }}</div>
  </div>
</template>

<script>
//Import InlineSvg from "vue-inline-svg"

export default {
  components: {
    //InlineSvg
  },
  props: {
    badge: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.user-badge {
  display: inline-flex;
  line-height: 12px;
  min-height: 12px;
  margin: 2px 0;

  &:not(:last-child) {
    margin-right: 8px;
  }
}

.user-badge-text {
  white-space: nowrap;
  padding: 2px 4px;
  overflow: hidden;
  text-overflow: ellipsis;

  &--with-icon {
    padding-left: 4px;
  }
}

.icon-wrapper {
  max-height: 16px;
  padding: 2px 0;
}
</style>
